import React from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import PropTypes from 'prop-types';

import style from './SubHeaderTitleStyle';

const SubHeaderTitle = ({ title, amount }) => (
  <View style={style.subHeaderTitle}>
    <VFText style={style.titleStyle} i18nKey={title} />
    <VFText style={style.amountStyle} i18nKey={amount} />
  </View>
);

SubHeaderTitle.defaultProps = {
  title: 'Total amount owed:',
  amount: '£50.00',
};

SubHeaderTitle.propTypes = {
  title: PropTypes.string,
  amount: PropTypes.string,
};
export default SubHeaderTitle;
